<template>
  <div class="container">
    <section class="content-header">
      <h1>{{$t('認証コード')}}</h1>
    </section>

    <section class="content-wrap">

      <div class="col-signup col-center">
        <div class="warning" id="warning" v-if="error.length">
          <ul>
            <li > {{ error[0] }}</li>
          </ul>
        </div>

        <form id="verifyUser" @submit.prevent="verifyUserEmail">
          <input v-model="verificationCode" v-on:blur="instantValidator($event, 'vrcf-code')" name="number" :placeholder="$t('認証コード')" required="required"  type="text" spellcheck="false" />
          <p class="caution" id="input-validation">{{inputValidation}}</p>
          <button v-bind:style="[inputValidation ? {'pointer-events':'none', 'background-color':'#c9cbcc'} : {}]" type="submit">{{$t('完了する')}}</button>
        </form>

      </div>

      <div class="resend_vf_code">
        <a href="javascript:;" id="resend_vf_code" @click="resendCode"> {{$t('確認コードを再送する')}}</a>
      </div>

      <div class="content-wrap">
        <div class="note">
          <h5>{{$t('確認メールが届かない場合')}}</h5>
          <ul>
            <li>{{$t('・迷惑メールとして処理されている可能性があります。迷惑メールフォルダをご確認ください。')}}</li>
            <li>{{$t('・メールがお手元に届くまでに時間がかかることがあります。')}}</li>
            <li>{{$t('・メールアドレスが間違っている等の理由でメールが届かない場合は、再度ご登録をお願いします。')}}</li>
          </ul>
        </div>
      </div>

    </section>
  </div>
</template>






<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import Cookie from 'js-cookie'
import User from '@/api/user'

export default {
  mounted () {
    let new_email = window.localStorage.getItem('newEmailForVerification')
    if(new_email != '' && new_email != 'null' && new_email != 'undefined' && new_email != null){
      this.email = this.$sanitize(JSON.parse(atob(new_email)))
    }
  },

  data : () => ({
    verificationCode: null,
    email: null,
    inputValidation: '',
    error:[]
  }),

  computed:{
    ...mapState(['user']),
    ...mapGetters({
      accessToken: 'accessToken',
      current_email: 'email',
    }),
  },  

  methods:{
    instantValidator(el, type){
      if(type === undefined) return; 
      if(type === 'vrcf-code'){
        if(!this.verificationCode){
          this.inputValidation = this.$t("Verification code field is empty.")
        }else if(this.verificationCode.length < 6){
          this.inputValidation = this.$t("Verification code is minimum 6 character.")
        }else{
          this.inputValidation = ""
        }
      }
    },


    verifyUserEmail(){

      if(!this.email){
        this.error.push(this.$t("Sorry, We cant't recognize your Email."))
        return
      }
      let bodyParameters = {
        accessToken: this.accessToken,
        type: 'email',
        code: this.$sanitize(this.verificationCode),
        email: this.email, // should be sanitize and validate
      }
// console.log(bodyParameters)
      User.verifyModifiedEmail(bodyParameters)
      .then((response) => {
        if(response.status === 200){
          this.$store.dispatch('setNewEmail', bodyParameters.email)

          this.$swal({
            title: this.$t('Email Attribute Verification confirmed!'),
            text: this.$t('You email address has been changed successfully! Please login with your new email.'),
            type: 'success',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: this.$t('ログイン')
          }).then((result) => {
              window.localStorage.removeItem('newEmailForVerification')
              Cookie.remove('_mua_c_aut_ls_t');
              Cookie.remove('_mua_c_aut_us_dtl');
              Cookie.remove('_mua_c_aut_em');
              this.logoutUser()
          }).catch((err) => {
              window.localStorage.removeItem('newEmailForVerification')
              Cookie.remove('_mua_c_aut_ls_t');
              Cookie.remove('_mua_c_aut_us_dtl');
              Cookie.remove('_mua_c_aut_em');
              this.logoutUser()
          })
        }else{
          // console.log(response)
          this.error.push(this.$t('Invalid code provided, please request a code again.'))
          return
        }
      })
      .catch(error => {
        // console.log(error)
        this.error.push(this.$t('Invalid code provided, please request a code again.'))  
        return
      })
    },

    logoutUser(){
      let provider = this.$store.state.userMeta.provider
      // this.$store.dispatch('logout')
      // console.log(process.env.COOKIES_DOMAIN)
      this.$store.dispatch('logout').then((result) => {
        Cookie.remove('CognitoIdentity.Provider', { domain: process.env.COOKIES_DOMAIN })
        Cookie.remove('CognitoIdentity.accessToken', { domain: process.env.COOKIES_DOMAIN })
        Cookie.remove('CognitoIdentity.cognitoIdentiyId', { domain: process.env.COOKIES_DOMAIN })
        Cookie.remove('CognitoIdentity.sns_registration', { domain: process.env.COOKIES_DOMAIN })
        Cookie.remove('CognitoIdentity.s_stamp', { domain: process.env.COOKIES_DOMAIN })
        if(provider === 'accounts.google.com' || provider === 'graph.facebook.com'){
          Cookie.set('ulso', 'true', { domain: process.env.COOKIES_DOMAIN });
        }

        // console.log(result)
        window.location = '/'
      }).catch((err) =>{
        // console.log(err)
      })
    },

    resendCode(){
      var bodyParameters = {
        type: 'email',
        email: this.email,
        accessToken: this.accessToken
      }
      if(!this.email){
        this.error.push(this.$t("Sorry, We cant't recognize your Email."))
        return
      }
      User.resendConfirmation(bodyParameters)
      .then((response) => {
        if(response.status == 200){
          this.$swal(
            this.$t('Resend Verification Code!'),
            this.$t('A verification code sent to your new email.'),
            'success'
          )
        }else{
          var unVerified_email = this.getNestedObject(response.data, ['error', 'message', 0, 'email', 0]);
          if(unVerified_email !== undefined){
            this.error.push(unVerified_email)
          }else{
            var e_m = this.getNestedObject(response.data, ['error', 'message', 0]);
            if(e_m !== undefined){
              this.error.push(e_m)
            }
          }            
        }
      })
      .catch(error => {
        this.error.push('Error occured!')
      })
    },    
    
    validateForm: function () {
      this.error = []
      if(!this.error.length) return true;
    },

    getNestedObject: function(nestedObj, pathArr){
      return pathArr.reduce((obj, key) => (obj && obj[key] !== 'undefined') ? obj[key] : undefined, nestedObj);
    },

  },


  //For Header & Meta Tag 
  metaInfo() {
    return {
      title: this.$t('認証コード') + ' | '+ this.$t('MATCHA - JAPAN TRAVEL WEB MAGAZINE'),
      htmlAttrs: {
        lang: this.$store.state.languageName
      },
    }
  },  


}

</script>






// WEBPACK FOOTER //
// src/pages/settings/emailverification.vue